var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Icon } from "../../UI";
import { removeNotification } from "../actions/notificationsActions";

export class Notification extends Component {
  close() {
    this.props.removeNotification(this.props.id);
  }

  render() {
    const { type, message } = this.props;
    const cssClass = `alert alert-${type}`;
    let icon = 'check';
    if (type === 'warning' || type === 'danger') {
      icon = 'exclamation-triangle';
    }

    const isNode = typeof message !== 'string';

    const FormattedMessage = isNode ?
    message :
    message.split('\n').map((item, i) => /*#__PURE__*/
    //eslint-disable-next-line react/no-array-index-key
    _jsx(React.Fragment, {}, i,
    item, /*#__PURE__*/
    _jsx("br", {})
    )
    );

    return /*#__PURE__*/(
      _jsx("div", { className: cssClass, onClick: this.close.bind(this) }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: icon }), /*#__PURE__*/
      _jsx("span", { className: "alert-text" }, void 0, FormattedMessage), /*#__PURE__*/
      _jsx(Icon, { icon: "times" })
      ));

  }
}

Notification.defaultProps = {
  type: 'success'
};








function mapDispatchToProps(dispatch) {
  return bindActionCreators({ removeNotification }, dispatch);
}

export default connect(null, mapDispatchToProps)(Notification);